import { render, staticRenderFns } from "./TipDialog.vue?vue&type=template&id=04ff3791&scoped=true"
import script from "./TipDialog.vue?vue&type=script&lang=js"
export * from "./TipDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ff3791",
  null
  
)

export default component.exports